<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.coupon_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.coupon_del">删除</el-button>
            </el-col>

            <!-- search start  -->
            <!-- <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.searchText" size="small" placeholder="请输入textContent" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col> -->
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="name" label="优惠卷名称" width="180"></el-table-column>
                    <el-table-column prop="content" label="描述" width="180"></el-table-column>
                    <el-table-column prop="mony" label="金额" width="100"></el-table-column>
                    <el-table-column prop="discount_ratio" label="抵扣比例" width="100"></el-table-column>
                    <el-table-column prop="upper_limit" label="优惠总金额上限" width="100"></el-table-column>
                    <el-table-column prop="min_money" label="满多少可用" width="100"></el-table-column>
                    <el-table-column prop="num_limit" label="使用次数上限" width="100"></el-table-column>
                    <el-table-column prop="oil_type" label="使用范围" width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.oil_type == 1">汽油</span>
                        <span v-if="scope.row.oil_type == 2">柴油</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="类型" width="100">
                      <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">加油券</span>
                        <span v-if="scope.row.type == 2">商品券</span>
                        <span v-if="scope.row.type == 3">洗车券</span>
                        <span v-if="scope.row.type == 4">加油抵扣卷</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="begin_time" label="开始时间" width="170"></el-table-column>
                    <el-table-column prop="end_time" label="过期时间" width="170"></el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.coupon_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.coupon_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="800px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="优惠卷名称"
                    :label-width="formLabelWidth"
                    prop="name"
                    :rules="[
                    { required: true, message: '请输入优惠卷名称', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="描述"
                    :label-width="formLabelWidth"
                    prop="content"
                    :rules="[
                    { required: true, message: '请输入描述', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.content" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="优惠券金额"
                    :label-width="formLabelWidth"
                    prop="mony"
                    :rules="[
                    { required: true, message: '请输入优惠券金额', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.mony" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="抵扣比例"
                    :label-width="formLabelWidth"
                    prop="discount_ratio"
                    :rules="[
                    { required: true, message: '请输入抵扣比例', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.discount_ratio" autocomplete="off" placeholder="请直接填写比例系数，如最高允许抵扣总金额的5%请填写0.05，允许一次用完，请填写1"></el-input>
                </el-form-item>
                <el-form-item label="满多少可用"
                    :label-width="formLabelWidth"
                    prop="min_money"
                    :rules="[
                    { required: true, message: '请输入满多少可用', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.min_money" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="优惠总金额上限"
                    :label-width="formLabelWidth"
                    prop="upper_limit"
                    :rules="[
                    { required: true, message: '请输入优惠总金额上限', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.upper_limit" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="使用次数上限"
                    :label-width="formLabelWidth"
                    prop="num_limit"
                    :rules="[
                    { required: true, message: '请输入使用次数上限', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num_limit" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="开始时间"
                    :label-width="formLabelWidth"
                    prop="begin_time"
                    :rules="[
                    { required: true, message: '请选择开始时间', trigger: 'blur' }
                    ]">
                    <el-date-picker
                        v-model="form.begin_time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="过期时间"
                    :label-width="formLabelWidth"
                    prop="end_time"
                    :rules="[
                    { required: true, message: '请选择过期时间', trigger: 'blur' }
                    ]">
                    <el-date-picker
                        v-model="form.end_time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择过期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="使用范围"
                    :label-width="formLabelWidth"
                    prop="oil_type"
                    :rules="[
                    { required: true, message: '请选择使用范围', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.oil_type" :label="1" border>汽油</el-radio>
                    <el-radio v-model="form.oil_type" :label="2" border>柴油</el-radio>
                </el-form-item>
                <el-form-item label="类型"
                    :label-width="formLabelWidth"
                    prop="type"
                    :rules="[
                    { required: true, message: '请选择类型', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.type" :label="1" border>加油券</el-radio>
                    <el-radio v-model="form.type" :label="2" border>商品券</el-radio>
                    <!-- <el-radio v-model="form.type" :label="3" border>洗车券</el-radio> -->
                    <el-radio v-model="form.type" :label="4" border>加油抵扣卷</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {CouponIndex, CouponAdd, CouponDel} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增优惠券",
                formLabelWidth: "140px",
                form: {
                    id: 0,
                    name: "",
                    content: "",
                    min_money: "",
                    mony: "",
                    upper_limit: "",
                    discount_ratio: "",
                    num_limit: 1,
                    begin_time: "",
                    end_time: "",
                    oil_type: 1,
                    type: 1,
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                CouponIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        CouponAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    name: data.name,
                    content: data.content,
                    min_money: data.min_money,
                    mony: data.mony,
                    discount_ratio: data.discount_ratio,
                    upper_limit: data.upper_limit,
                    num_limit: data.num_limit,
                    begin_time: data.begin_time,
                    end_time: data.end_time,
                    oil_type: data.oil_type,
                    type: data.type,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑优惠券" : "新增优惠券"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    name: "",
                    content: "",
                    min_money: "",
                    mony: "",
                    upper_limit: "",
                    discount_ratio: "",
                    num_limit: 1,
                    begin_time: "",
                    end_time: "",
                    oil_type: 1,
                    type: 1,
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增优惠券"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    CouponDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
        }
    }
</script>

<style>
</style>
